import React from "react";
import styled from "styled-components";

import Copyright from "./Copyright";

const StyledFooter = styled.footer`
  margin-top: 3rem;
`;
function Footer() {
  return (
    <StyledFooter className="footer">
      <Copyright align="left" color="black" />
    </StyledFooter>
  );
}

export default Footer;
